/** * 门店日报表 */
<template>
	<div class="report-page">
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="search">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期：">
					<el-date-picker v-model="formInline.statisticDate" type="date" value-format="yyyy-MM-dd" format="yyyy年MM月dd日" placeholder="请选择日期" size="small" @change="search"></el-date-picker>
				</el-form-item>
				<el-form-item class="btnList">
					<el-button v-if="$checkBtnPermission('/storeDayReport/index', 'viewPage')" size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
				</el-form-item>
			</el-form>

			<div class="report-title">
				<div class="title-decoration"></div>
				<span>{{ title }}</span>
			</div>

			<div v-if="Object.keys(dayReportInfo).length > 0" class="reportContent">
				<el-row :gutter="16" class="main-row">
					<el-col :span="10">
						<el-card class="report-card customer-table-card">
							<template #header>
								<div class="card-header">
									<span class="header-title">
										<i class="el-icon-user"></i>
										新进店顾客信息
									</span>
								</div>
							</template>
							<el-table :cell-class-name="$moneyCellClass" :data="dayReportInfo.reportCustomers || []" border size="small" stripe max-height="350" style="width: 100%">
								<el-table-column type="index" label="序号" width="60" align="center" />
								<el-table-column prop="receiptionUserName" label="接待人" min-width="80" align="center" />
								<el-table-column prop="inStoreCustomerCount" label="进店顾客" width="90" align="center" />
								<el-table-column prop="inStoreOrderCustomerCount" label="进店成交" width="100" align="center" />
								<el-table-column label="成交率" width="80" align="center">
									<template #default="scope">
										<span class="rate-value">{{ (((scope.row.inStoreOrderCustomerCount || 0) / (scope.row.inStoreCustomerCount || 1)) * 100).toFixed(1) }}%</span>
									</template>
								</el-table-column>
							</el-table>
						</el-card>
					</el-col>

					<el-col :span="14" class="right-stats">
						<el-card class="report-card">
							<template #header>
								<div class="card-header">
									<span class="header-title">
										<i class="el-icon-s-marketing"></i>
										今日进店类型
									</span>
									<span class="header-badge">{{ todayInStoreTotal }} 人</span>
								</div>
							</template>
							<el-row :gutter="10">
								<el-col v-for="(item, index) in dayReportInfo.inStoreTypes || []" :key="index" :span="8">
									<div class="stat-item" :class="{ 'no-margin': isLastRow(index, (dayReportInfo.inStoreTypes || []).length, 3) }">
										<div class="stat-label">{{ item.typeName }}</div>
										<div class="stat-value">{{ item.count || 0 }}</div>
									</div>
								</el-col>
								<el-col v-if="(dayReportInfo.inStoreTypes || []).length === 0" :span="24">
									<div class="empty-data-small">暂无数据</div>
								</el-col>
							</el-row>
						</el-card>

						<el-row :gutter="12" class="bottom-stats-row">
							<el-col :span="12">
								<el-card class="report-card">
									<template #header>
										<div class="card-header">
											<span class="header-title">
												<i class="el-icon-date"></i>
												本月进店类型
											</span>
											<span class="header-badge">{{ monthInStoreTotal }} 人</span>
										</div>
									</template>
									<el-row :gutter="10">
										<el-col v-for="(item, index) in dayReportInfo.monthInStoreTypes || []" :key="index" :span="8">
											<div class="stat-item" :class="{ 'no-margin': isLastRow(index, (dayReportInfo.monthInStoreTypes || []).length, 3) }">
												<div class="stat-label">{{ item.typeName }}</div>
												<div class="stat-value">{{ item.count || 0 }}</div>
											</div>
										</el-col>
										<el-col v-if="(dayReportInfo.monthInStoreTypes || []).length === 0" :span="24">
											<div class="empty-data-small">暂无数据</div>
										</el-col>
									</el-row>
								</el-card>
							</el-col>
							<el-col :span="12">
								<el-card class="report-card">
									<template #header>
										<div class="card-header">
											<span class="header-title">
												<i class="el-icon-data-analysis"></i>
												顾客数据
											</span>
										</div>
									</template>
									<el-row :gutter="10">
										<el-col :span="12">
											<div class="stat-item highlight">
												<div class="stat-label">今日老顾客成交</div>
												<div class="stat-value">
													{{ dayReportInfo.oldCustomerSpendOrderCount || 0 }}
													<span class="unit">单</span>
												</div>
											</div>
										</el-col>
										<el-col :span="12">
											<div class="stat-item highlight">
												<div class="stat-label">本月总进店顾客</div>
												<div class="stat-value">
													{{ dayReportInfo.totalCustomerInStore || 0 }}
													<span class="unit">人</span>
												</div>
											</div>
										</el-col>
										<el-col :span="12">
											<div class="stat-item highlight no-margin">
												<div class="stat-label">本月进店老顾客成交</div>
												<div class="stat-value">
													{{ dayReportInfo.monthOldInStoreSpendOrderCount || 0 }}
													<span class="unit">单</span>
												</div>
											</div>
										</el-col>
										<el-col :span="12">
											<div class="stat-item highlight no-margin">
												<div class="stat-label">本月进店顾客成交</div>
												<div class="stat-value">
													{{ dayReportInfo.monthInStoreSpendOrderCount || 0 }}
													<span class="unit">单</span>
												</div>
											</div>
										</el-col>
									</el-row>
								</el-card>
							</el-col>
						</el-row>
					</el-col>
				</el-row>

				<el-row :gutter="16" class="main-row">
					<el-col :span="14">
						<el-card class="report-card">
							<template #header>
								<div class="card-header">
									<span class="header-title">
										<i class="el-icon-document-copy"></i>
										今日销售数据
									</span>
								</div>
							</template>
							<el-row :gutter="12">
								<el-col :span="8">
									<div class="stat-item money">
										<div class="stat-label">商品销售总额</div>
										<div class="stat-value" v-money="dayReportInfo.productMoney">¥{{ dayReportInfo.productMoney || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item money">
										<div class="stat-label">销售金额</div>
										<div class="stat-value" v-money="dayReportInfo.salesMoney">¥{{ dayReportInfo.salesMoney || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item money">
										<div class="stat-label">实收金额</div>
										<div class="stat-value" v-money="dayReportInfo.realPayMoney">¥{{ dayReportInfo.realPayMoney || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item money no-margin">
										<div class="stat-label">今日清欠款</div>
										<div class="stat-value" v-money="dayReportInfo.dayClearPayment">¥{{ dayReportInfo.dayClearPayment || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item money no-margin">
										<div class="stat-label">今日欠款</div>
										<div class="stat-value" v-money="dayReportInfo.dayPayment">¥{{ dayReportInfo.dayPayment || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item money no-margin">
										<div class="stat-label">会员卡销付款</div>
										<div class="stat-value" v-money="dayReportInfo.dayVipPayMoney">¥{{ dayReportInfo.dayVipPayMoney || 0 }}</div>
									</div>
								</el-col>
							</el-row>
						</el-card>
					</el-col>
					<el-col :span="10">
						<el-card class="report-card">
							<template #header>
								<div class="card-header">
									<span class="header-title">
										<i class="el-icon-document-checked"></i>
										本月销售数据
									</span>
								</div>
							</template>
							<el-row :gutter="12">
								<el-col :span="12">
									<div class="stat-item money">
										<div class="stat-label">本月商品总额</div>
										<div class="stat-value" v-money="dayReportInfo.monthProductMoney">¥{{ dayReportInfo.monthProductMoney || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="stat-item money">
										<div class="stat-label">本月销售金额</div>
										<div class="stat-value" v-money="dayReportInfo.monthSalesMoney">¥{{ dayReportInfo.monthSalesMoney || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="stat-item money no-margin">
										<div class="stat-label">本月实收金额</div>
										<div class="stat-value" v-money="dayReportInfo.monthRealPayMoney">¥{{ dayReportInfo.monthRealPayMoney || 0 }}</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="stat-item money no-margin">
										<div class="stat-label">本月欠款</div>
										<div class="stat-value" v-money="dayReportInfo.monthPayment">¥{{ dayReportInfo.monthPayment || 0 }}</div>
									</div>
								</el-col>
							</el-row>
						</el-card>
					</el-col>
				</el-row>

				<el-row :gutter="16" class="main-row">
					<el-col :span="12">
						<el-card class="report-card">
							<template #header>
								<div class="card-header">
									<span class="header-title">
										<i class="el-icon-coin"></i>
										今日收款类型
									</span>
									<span class="header-badge money" v-money="todayPaymentTotal">¥{{ todayPaymentTotal }}</span>
								</div>
							</template>
							<el-row :gutter="12">
								<el-col v-for="(item, index) in (dayReportInfo.payMoneys || []).slice(0, 4)" :key="'today1-' + index" :span="6">
									<div class="stat-item money">
										<div class="stat-label">{{ item.payTypeName }}</div>
										<div class="stat-value" v-money="item.payMoney">¥{{ item.payMoney || 0 }}</div>
									</div>
								</el-col>
							</el-row>
							<el-row v-if="(dayReportInfo.payMoneys || []).length > 4" :gutter="12">
								<el-col v-for="(item, index) in (dayReportInfo.payMoneys || []).slice(4, 8)" :key="'today2-' + index" :span="6">
									<div class="stat-item money no-margin">
										<div class="stat-label">{{ item.payTypeName }}</div>
										<div class="stat-value" v-money="item.payMoney">¥{{ item.payMoney || 0 }}</div>
									</div>
								</el-col>
							</el-row>
							<div v-if="(dayReportInfo.payMoneys || []).length === 0" class="empty-data-small">暂无数据</div>
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card class="report-card">
							<template #header>
								<div class="card-header">
									<span class="header-title">
										<i class="el-icon-coin"></i>
										本月收款类型
									</span>
									<span class="header-badge money" v-money="monthPaymentTotal">¥{{ monthPaymentTotal }}</span>
								</div>
							</template>
							<el-row :gutter="12">
								<el-col v-for="(item, index) in (dayReportInfo.monthPayMoneys || []).slice(0, 4)" :key="'month1-' + index" :span="6">
									<div class="stat-item money">
										<div class="stat-label">{{ item.payTypeName }}</div>
										<div class="stat-value" v-money="item.payMoney">¥{{ item.payMoney || 0 }}</div>
									</div>
								</el-col>
							</el-row>
							<el-row v-if="(dayReportInfo.monthPayMoneys || []).length > 4" :gutter="12">
								<el-col v-for="(item, index) in (dayReportInfo.monthPayMoneys || []).slice(4, 8)" :key="'month2-' + index" :span="6">
									<div class="stat-item money no-margin">
										<div class="stat-label">{{ item.payTypeName }}</div>
										<div class="stat-value" v-money="item.payMoney">¥{{ item.payMoney || 0 }}</div>
									</div>
								</el-col>
							</el-row>
							<div v-if="(dayReportInfo.monthPayMoneys || []).length === 0" class="empty-data-small">暂无数据</div>
						</el-card>
					</el-col>
				</el-row>
			</div>

			<div v-else class="empty-data">
				<el-empty description="暂无数据"></el-empty>
			</div>
		</topTab>
	</div>
</template>

<script>
import { GetStoreDayReport } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "门店日报表"
				}
			],
			loading: false,
			formInline: {
				storeKeyId: "",
				statisticDate: new Date()
			},
			storeList: [],
			dayReportInfo: {},
			title: "日报表"
		};
	},
	components: {},
	created() {
		this.GetOrgInfoListByConfig();
		this.search();
	},
	computed: {
		todayInStoreTotal() {
			if (!this.dayReportInfo.inStoreTypes || this.dayReportInfo.inStoreTypes.length === 0) {
				return 0;
			}
			return this.dayReportInfo.inStoreTypes.reduce((total, item) => {
				return total + (item.count || 0);
			}, 0);
		},
		monthInStoreTotal() {
			if (!this.dayReportInfo.monthInStoreTypes || this.dayReportInfo.monthInStoreTypes.length === 0) {
				return 0;
			}
			return this.dayReportInfo.monthInStoreTypes.reduce((total, item) => {
				return total + (item.count || 0);
			}, 0);
		},
		todayPaymentTotal() {
			if (!this.dayReportInfo.payMoneys || this.dayReportInfo.payMoneys.length === 0) {
				return 0;
			}
			return this.dayReportInfo.payMoneys.reduce((total, item) => {
				return total + (item.payMoney || 0);
			}, 0);
		},
		monthPaymentTotal() {
			if (!this.dayReportInfo.monthPayMoneys || this.dayReportInfo.monthPayMoneys.length === 0) {
				return 0;
			}
			return this.dayReportInfo.monthPayMoneys.reduce((total, item) => {
				return total + (item.payMoney || 0);
			}, 0);
		}
	},
	methods: {
		changePages() {},
		isLastRow(index, total, perRow) {
			if (perRow === 3) {
				const remainder = total % 3;
				const lastRowCount = remainder === 0 ? 3 : remainder;
				const lastRowStart = total - lastRowCount;
				return index >= lastRowStart;
			} else if (perRow === 4) {
				const remainder = total % 4;
				const lastRowCount = remainder === 0 ? 4 : remainder;
				const lastRowStart = total - lastRowCount;
				return index >= lastRowStart;
			}
			return false;
		},
		search() {
			this.getListData();
		},
		getListData() {
			if (!this.$checkBtnPermission("/storeDayReport/index", "viewPage")) {
				this.$message.error("您没有权限查看门店日报表！");
				return;
			}
			GetStoreDayReport(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.dayReportInfo = res.data;
						this.title = this.dayReportInfo.statisticDate + "【" + this.dayReportInfo.storeName + "】日报表";
					} else {
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped lang="scss">
.report-page {
	background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
}

.user-search {
	background: #ffffff;
	padding: 10px 14px;
	border-radius: 8px;
	margin-bottom: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	border: 1px solid #f0f0f0;
}

.report-title {
	font-size: 18px;
	font-weight: 700;
	text-align: center;
	background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
	color: #fff;
	padding: 12px 16px;
	line-height: 1.5;
	border-radius: 8px;
	margin-bottom: 12px;
	box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
	position: relative;
	flex-shrink: 0;
	box-sizing: border-box;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		z-index: 0;
		pointer-events: none;
		border-radius: 8px;
		overflow: hidden;
		background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
	}

	span {
		position: relative;
		z-index: 2;
		display: block;
	}
}

@keyframes shine {
	0% {
		transform: translateX(-100%) rotate(45deg);
	}
	100% {
		transform: translateX(100%) rotate(45deg);
	}
}

.reportContent {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-bottom: 30px;
}

.main-row {
	display: flex;
	row-gap: 12px;
	column-gap: 0;
}

.report-card {
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
	border: none;
	overflow: hidden;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
		transform: translateY(-1px);
	}

	::v-deep .el-card__header {
		padding: 10px 14px;
		background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
		border-bottom: 1px solid #e2e8f0;
	}

	::v-deep .el-card__body {
		padding: 10px;
	}
}

.customer-table-card {
	height: 100%;

	::v-deep .el-table {
		border-radius: 8px;
		overflow: hidden;

		th {
			background: #f8fafc !important;
			color: #303133;
			font-weight: 600;
		}

		.el-table__row:hover > td {
			background: #f0f7ff !important;
		}
	}
}

.right-stats {
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: stretch;
}

.bottom-stats-row {
	display: flex;
	flex: 1;

	> .el-col {
		display: flex;
		flex-direction: column;

		.report-card {
			flex: 1;
		}
	}
}

.card-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.header-title {
	font-size: 15px;
	font-weight: 600;
	color: #303133;
	display: flex;
	align-items: center;
	gap: 8px;

	i {
		font-size: 18px;
		color: #409eff;
	}
}

.header-badge {
	font-size: 13px;
	font-weight: 600;
	color: #fff;
	background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
	padding: 2px 10px;
	border-radius: 20px;
	box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

	&.money {
		background: linear-gradient(135deg, #e6a23c 0%, #f56c6c 100%);
		box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
	}
}

.stat-item {
	background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
	border-radius: 6px;
	padding: 8px 10px;
	border: 1px solid #e2e8f0;
	transition: all 0.2s ease;
	text-align: center;
	position: relative;
	overflow: hidden;
	margin-bottom: 8px;

	&.no-margin {
		margin-bottom: 0;
	}

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 2px;
		background: linear-gradient(90deg, #409eff, #67c23a);
		opacity: 0;
		transition: opacity 0.2s;
	}

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 3px 10px rgba(64, 158, 255, 0.15);
		border-color: #409eff;

		&::before {
			opacity: 1;
		}
	}

	&.highlight {
		background: linear-gradient(145deg, #fff 0%, #f0f7ff 100%);
		border-color: #c6e2ff;

		&::before {
			background: linear-gradient(90deg, #409eff, #73c0de);
		}
	}

	&.money {
		background: linear-gradient(145deg, #fff9f0 0%, #fef0e6 100%);
		border-color: #fde2c6;

		&::before {
			background: linear-gradient(90deg, #e6a23c, #f56c6c);
		}
	}
}

.stat-label {
	font-size: 12px;
	color: #64748b;
	margin-bottom: 8px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.stat-value {
	font-size: 18px;
	font-weight: 700;
	color: #1e293b;
	font-family: "Helvetica Neue", Arial, sans-serif;

	.unit {
		font-size: 12px;
		font-weight: 500;
		color: #909399;
	}
}

.rate-value {
	color: #67c23a;
	font-weight: 600;
}

.empty-data {
	text-align: center;
	padding: 60px 0;
	background: #ffffff;
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.empty-data-small {
	text-align: center;
	padding: 20px;
	color: #909399;
	font-size: 13px;
}

@media (max-width: 1200px) {
	.main-row {
		flex-direction: column;
	}

	.main-row > .el-col {
		width: 100% !important;
	}

	.right-stats {
		flex-direction: row;
	}

	.right-stats > .report-card {
		flex: 1;
	}
}

@media (max-width: 768px) {
	.report-page {
		padding: 8px;
	}

	.report-title {
		font-size: 16px;
		padding: 12px 16px;
	}

	.right-stats {
		flex-direction: column;
	}

	::v-deep .el-card__body {
		padding: 12px;
	}
}
</style>
